import { FC, useState } from 'react'
import { DropdownSelector, ImportButton, Box } from '../../../ui'
import { Divider, Alert, InputNumber } from 'antd'
import style from './style.m.less'
import { useTranslation } from 'react-i18next'
import { userTypeIdPicker } from '../../../helpers'
import { Search, Trash, Edit } from '../../../../assets/icons'
import { SearchConsumer, AddConsumer } from '../'
import { SearchPrevConsumer } from '../../../CertificateRepayment/components'

const options = [
    //{ id: 'Физическое лицо', value: 'Физическое лицо' },
    { id: 'Юридическое лицо', value: 'Юридическое лицо' },
    //{ id: 'Индивидуальный предприниматель', value: 'Индивидуальный предприниматель' },
]

interface IConsumerBlock {
    index: number
    totalVolume: number
    updateRepayments: (index: number, key: string, value: number) => void
}

const ConsumerBlock: FC<IConsumerBlock> = ({ index, updateRepayments, totalVolume }) => {
    const { t } = useTranslation()
    const [type, setType] = useState(null)
    const [selected, setSelected] = useState<any>(undefined)
    const [volume, setVolume] = useState(0)
    const [volumeTouched, setVolumeTouched] = useState(false)

    const selectHandle = (consumer: any) => {
        setSelected(consumer)
        updateRepayments(index, 'user_id', consumer.uid)
    }

    const selectManualHandle = (consumer: any) => {
        consumer.user_type = userTypeIdPicker(type)
        setSelected(consumer)
        updateRepayments(index, 'consumer_data', consumer)
    }

    const selectUnregistredHandle = (consumer: any) => {
        setSelected(consumer)
        updateRepayments(index, 'consumer_data', consumer)
    }

    const clearCard = () => {
        setSelected(undefined)
        setType(null)
        updateRepayments(index, 'user_id', '')
    }

    const [isSearchConsumerModalVisible, setIsSearchConsumerModalVisible] = useState(false)
    const openSearchConsumerModal = () => {
        setIsSearchConsumerModalVisible(true)
    }

    const [isAddConsumerModalVisible, setIsAddConsumerModalVisible] = useState(false)
    const openAddConsumerModal = () => {
        setIsAddConsumerModalVisible(true)
    }

    const [isSearchPrevConsumerModalVisible, setIsSearchPrevConsumerModalVisible] = useState(false)
    const openSearchPrevConsumerModal = () => {
        setIsSearchPrevConsumerModalVisible(true)
    }
    return (
        <div className={style.inputWrapper}>
            {!selected && (
                <>
                    <div className={style.label}>Потребитель</div>
                    <DropdownSelector
                        placeholder="Выберите потребителя"
                        noDefaultValue
                        options={options}
                        customStyle={{
                            width: '400px',
                        }}
                        onChange={(value: any) => {
                            updateRepayments(index, 'user_id', '')
                            setType(value)
                        }}
                    />
                </>
            )}
            {type && !selected && (
                <div className={style.linkWrapper}>
                    <ImportButton
                        value="Найти в системе"
                        icon={<Search />}
                        onClick={openSearchConsumerModal}
                    />

                    <Divider type="vertical" style={{ height: '22px', margin: '0 16px' }} />
                    <ImportButton
                        value="Найти из ранее указанных"
                        icon={<Search />}
                        onClick={openSearchPrevConsumerModal}
                    />

                    <Divider type="vertical" style={{ height: '22px', margin: '0 16px' }} />
                    <ImportButton
                        value="Заполнить вручную"
                        icon={<Edit />}
                        onClick={openAddConsumerModal}
                    />
                </div>
            )}
            {selected && type === 'Физическое лицо' && (
                <Alert
                    className={style.resultAlert}
                    message={
                        <div className={style.alertTitleWrapper}>
                            <span className={style.alertTitle}>
                                {`${selected.first_name} ${selected.middle_name} ${selected.last_name}`}
                            </span>
                            <div className={style.alertIconWrapper}>
                                <div className={style.icon} onClick={clearCard}>
                                    <Trash />
                                </div>
                            </div>
                        </div>
                    }
                    description={
                        selected?.personal_account_number ? (
                            <span
                                className={style.alertDetail}
                            >{`Номер ЛС ${selected.personal_account_number}`}</span>
                        ) : null
                    }
                    type="info"
                />
            )}
            {selected && type === 'Юридическое лицо' && (
                <Alert
                    className={style.resultLegalAlert}
                    message={
                        <div className={style.alertTitleWrapper}>
                            <span className={style.alertTitle}>{selected.company_name_short}</span>
                            <div className={style.alertIconWrapper}>
                                <div className={style.icon} onClick={clearCard}>
                                    <Trash />
                                </div>
                            </div>
                        </div>
                    }
                    description={
                        <>
                            <span className={style.alertDetail}>{`ИНН ${
                                selected.company_inn ? selected.company_inn : selected.inn
                            }`}</span>
                            <Divider type="vertical" />
                            <span className={style.alertDetail}>{`ОГРН ${selected.ogrn}`}</span>
                            <Divider type="vertical" />
                            <span className={style.alertDetail}>{`КПП ${selected.kpp}`}</span>
                        </>
                    }
                    type="info"
                />
            )}
            {selected && type === 'Индивидуальный предприниматель' && (
                <Alert
                    className={style.resultAlert}
                    message={
                        <div className={style.alertTitleWrapper}>
                            <span
                                className={style.alertTitle}
                            >{`ИП ${selected.last_name} ${selected.first_name} ${selected.middle_name}`}</span>
                            <div className={style.alertIconWrapper}>
                                <div className={style.icon} onClick={clearCard}>
                                    <Trash />
                                </div>
                            </div>
                        </div>
                    }
                    description={
                        <>
                            <span className={style.alertDetail}>{`ИНН ${
                                selected.personal_inn ? selected.personal_inn : selected.inn
                            }`}</span>
                            <Divider type="vertical" />
                            <span className={style.alertDetail}>{`ОГРНИП ${selected.ogrn}`}</span>
                        </>
                    }
                    type="info"
                />
            )}
            {type && (
                <Box style={{ marginTop: '16px' }}>
                    <div className={style.label}>Объем</div>
                    <InputNumber
                        placeholder="Введите объем"
                        className={style.input}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
                        style={
                            volume > totalVolume || (volumeTouched && (!volume || volume === 0))
                                ? { borderColor: '#FF7875' }
                                : undefined
                        }
                        controls={false}
                        onKeyDown={(event: any) => {
                            if (event.key === 'Backspace') {
                                return
                            }
                            if (/[^0-9]/.test(event.key)) {
                                event.preventDefault()
                            }
                        }}
                        onBlur={() => setVolumeTouched(true)}
                        onChange={(value: number | null) => {
                            value = value ? value : 0
                            setVolume(value)
                            updateRepayments(index, 'volume', value)
                        }}
                    />
                    {volumeTouched && (!volume || volume === 0) && (
                        <div className={style.explain}>Укажите объем больше 0 кВт*ч</div>
                    )}
                    {volume > totalVolume && (
                        <div className={style.explain}>
                            Укажите число, соответствующее объему договора
                        </div>
                    )}
                </Box>
            )}
            <Divider />
            <SearchConsumer
                isModalVisible={isSearchConsumerModalVisible}
                setIsModalVisible={() => setIsSearchConsumerModalVisible(false)}
                userType={userTypeIdPicker(type)}
                selectHandle={selectHandle}
            />
            <SearchPrevConsumer
                isModalVisible={isSearchPrevConsumerModalVisible}
                setIsModalVisible={() => setIsSearchPrevConsumerModalVisible(false)}
                selectHandle={selectUnregistredHandle}
                userType={userTypeIdPicker(type)}
            />
            {isAddConsumerModalVisible && (
                <AddConsumer
                    isModalVisible={isAddConsumerModalVisible}
                    setIsModalVisible={() => setIsAddConsumerModalVisible(false)}
                    userType={userTypeIdPicker(type)}
                    selectHandle={selectManualHandle}
                />
            )}
        </div>
    )
}

export default ConsumerBlock
